export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10761.f3d03987.jpg";